export const WORD_PAIRS = [
  { civilian: 'Cat', imposter: 'Lion' },
  { civilian: 'Dog', imposter: 'Fox' },
  { civilian: 'Cow', imposter: 'Deer' },
  { civilian: 'Goat', imposter: 'Horse' },
  { civilian: 'Elephant', imposter: 'Rhino' },
  { civilian: 'Snake', imposter: 'Lizard' },
  { civilian: 'Crow', imposter: 'Eagle' },
  { civilian: 'Parrot', imposter: 'Peacock' },
  { civilian: 'Fish', imposter: 'Octopus' },
  { civilian: 'Shark', imposter: 'Whale' },
  { civilian: 'Apple', imposter: 'Watermelon' },
  { civilian: 'Banana', imposter: 'Pineapple' },
  { civilian: 'Orange', imposter: 'Papaya' },
  { civilian: 'Mango', imposter: 'Guava' },
  { civilian: 'Grapes', imposter: 'Pomegranate' },
  { civilian: 'Potato', imposter: 'Carrot' },
  { civilian: 'Onion', imposter: 'Garlic' },
  { civilian: 'Tomato', imposter: 'Beetroot' },
  { civilian: 'Cabbage', imposter: 'Spinach' },
  { civilian: 'Corn', imposter: 'Peas' },
  { civilian: 'Car', imposter: 'Airplane' },
  { civilian: 'Bike', imposter: 'Boat' },
  { civilian: 'Bus', imposter: 'Train' },
  { civilian: 'Scooter', imposter: 'Truck' },
  { civilian: 'Cycle', imposter: 'Helicopter' },
  { civilian: 'Metro', imposter: 'Ship' },
  { civilian: 'Auto', imposter: 'Taxi' },
  { civilian: 'Rocket', imposter: 'Submarine' },
  { civilian: 'Jeep', imposter: 'Tractor' },
  { civilian: 'Van', imposter: 'Ambulance' },
  { civilian: 'Coffee', imposter: 'Milkshake' },
  { civilian: 'Tea', imposter: 'Juice' },
  { civilian: 'Water', imposter: 'Soda' },
  { civilian: 'Soup', imposter: 'Dal' },
  { civilian: 'Rice', imposter: 'Bread' },
  { civilian: 'Noodles', imposter: 'Pasta' },
  { civilian: 'Pizza', imposter: 'Biryani' },
  { civilian: 'Burger', imposter: 'Sandwich' },
  { civilian: 'Cake', imposter: 'Ice cream' },
  { civilian: 'Chocolate', imposter: 'Ladoo' },
  { civilian: 'Shirt', imposter: 'Sweater' },
  { civilian: 'Pants', imposter: 'Shorts' },
  { civilian: 'Jacket', imposter: 'Raincoat' },
  { civilian: 'Shoes', imposter: 'Slippers' },
  { civilian: 'Cap', imposter: 'Helmet' },
  { civilian: 'Watch', imposter: 'Bracelet' },
  { civilian: 'Ring', imposter: 'Necklace' },
  { civilian: 'Belt', imposter: 'Tie' },
  { civilian: 'Gloves', imposter: 'Socks' },
  { civilian: 'Scarf', imposter: 'Shawl' },
  { civilian: 'Chair', imposter: 'Bed' },
  { civilian: 'Table', imposter: 'Cupboard' },
  { civilian: 'Sofa', imposter: 'Bench' },
  { civilian: 'Door', imposter: 'Gate' },
  { civilian: 'Window', imposter: 'Mirror' },
  { civilian: 'Fan', imposter: 'Cooler' },
  { civilian: 'AC', imposter: 'Heater' },
  { civilian: 'Lamp', imposter: 'Torch' },
  { civilian: 'Clock', imposter: 'Calendar' },
  { civilian: 'Carpet', imposter: 'Curtain' },
  { civilian: 'Sun', imposter: 'Star' },
  { civilian: 'Moon', imposter: 'Planet' },
  { civilian: 'Earth', imposter: 'Mars' },
  { civilian: 'Rain', imposter: 'Fog' },
  { civilian: 'Snow', imposter: 'Hail' },
  { civilian: 'Wind', imposter: 'Thunder' },
  { civilian: 'Lightning', imposter: 'Volcano' },
  { civilian: 'River', imposter: 'Waterfall' },
  { civilian: 'Ocean', imposter: 'Glacier' },
  { civilian: 'Desert', imposter: 'Forest' },
  { civilian: 'Doctor', imposter: 'Engineer' },
  { civilian: 'Teacher', imposter: 'Lawyer' },
  { civilian: 'Police', imposter: 'Judge' },
  { civilian: 'Chef', imposter: 'Farmer' },
  { civilian: 'Driver', imposter: 'Pilot' },
  { civilian: 'Actor', imposter: 'Singer' },
  { civilian: 'Dancer', imposter: 'Athlete' },
  { civilian: 'Writer', imposter: 'Painter' },
  { civilian: 'Soldier', imposter: 'Spy' },
  { civilian: 'Scientist', imposter: 'Astronaut' },
  { civilian: 'Cricket', imposter: 'Hockey' },
  { civilian: 'Football', imposter: 'Basketball' },
  { civilian: 'Tennis', imposter: 'Golf' },
  { civilian: 'Chess', imposter: 'Poker' },
  { civilian: 'Ludo', imposter: 'Carrom' },
  { civilian: 'Badminton', imposter: 'Table tennis' },
  { civilian: 'Volleyball', imposter: 'Rugby' },
  { civilian: 'Boxing', imposter: 'Wrestling' },
  { civilian: 'Marathon', imposter: 'Sprint' },
  { civilian: 'Gym', imposter: 'Yoga' },
  { civilian: 'Book', imposter: 'Movie' },
  { civilian: 'Newspaper', imposter: 'Podcast' },
  { civilian: 'Magazine', imposter: 'Blog' },
  { civilian: 'Cartoon', imposter: 'Documentary' },
  { civilian: 'Song', imposter: 'Speech' },
  { civilian: 'Guitar', imposter: 'Flute' },
  { civilian: 'Piano', imposter: 'Drums' },
  { civilian: 'Camera', imposter: 'Microphone' },
  { civilian: 'Photo', imposter: 'Video' },
  { civilian: 'Painting', imposter: 'Sculpture' },
  { civilian: 'City', imposter: 'Village' },
  { civilian: 'Mall', imposter: 'Street market' },
  { civilian: 'School', imposter: 'Office' },
  { civilian: 'Hospital', imposter: 'Pharmacy' },
  { civilian: 'Bank', imposter: 'Post office' },
  { civilian: 'Airport', imposter: 'Bus stand' },
  { civilian: 'Railway station', imposter: 'Port' },
  { civilian: 'Hotel', imposter: 'Hostel' },
  { civilian: 'Restaurant', imposter: 'Dhaba' },
  { civilian: 'Cafe', imposter: 'Bar' },
  { civilian: 'Bag', imposter: 'Suitcase' },
  { civilian: 'Wallet', imposter: 'Locker' },
  { civilian: 'Bottle', imposter: 'Jug' },
  { civilian: 'Glass', imposter: 'Cup' },
  { civilian: 'Plate', imposter: 'Bowl' },
  { civilian: 'Spoon', imposter: 'Chopsticks' },
  { civilian: 'Knife', imposter: 'Axe' },
  { civilian: 'Key', imposter: 'Password' },
  { civilian: 'Lock', imposter: 'Alarm' },
  { civilian: 'Box', imposter: 'Basket' },
  { civilian: 'Phone', imposter: 'TV' },
  { civilian: 'Laptop', imposter: 'Tablet' },
  { civilian: 'Remote', imposter: 'Switch' },
  { civilian: 'Charger', imposter: 'Battery' },
  { civilian: 'Cable', imposter: 'Adapter' },
  { civilian: 'App', imposter: 'Software' },
  { civilian: 'Website', imposter: 'Platform' },
  { civilian: 'Email', imposter: 'Letter' },
  { civilian: 'Call', imposter: 'Meeting' },
  { civilian: 'Message', imposter: 'Notification' },
  { civilian: 'Beach', imposter: 'Mountain' },
  { civilian: 'Island', imposter: 'Desert' },
  { civilian: 'Bridge', imposter: 'Flyover' },
  { civilian: 'Tunnel', imposter: 'Road' },
  { civilian: 'Park', imposter: 'Zoo' },
  { civilian: 'Garden', imposter: 'Farm' },
  { civilian: 'Temple', imposter: 'Church' },
  { civilian: 'Mosque', imposter: 'Gurudwara' },
  { civilian: 'Museum', imposter: 'Library' },
  { civilian: 'Stadium', imposter: 'Theater' },
  { civilian: 'Gold', imposter: 'Iron' },
  { civilian: 'Silver', imposter: 'Copper' },
  { civilian: 'Diamond', imposter: 'Coal' },
  { civilian: 'Wood', imposter: 'Plastic' },
  { civilian: 'Paper', imposter: 'Cloth' },
  { civilian: 'Glass', imposter: 'Steel' },
  { civilian: 'Rubber', imposter: 'Leather' },
  { civilian: 'Cement', imposter: 'Sand' },
  { civilian: 'Brick', imposter: 'Tile' },
  { civilian: 'Clay', imposter: 'Stone' },
  { civilian: 'Baby', imposter: 'Adult' },
  { civilian: 'Boy', imposter: 'Girl' },
  { civilian: 'Man', imposter: 'Woman' },
  { civilian: 'King', imposter: 'Soldier' },
  { civilian: 'Queen', imposter: 'Maid' },
  { civilian: 'Teacher', imposter: 'Student' },
  { civilian: 'Boss', imposter: 'Employee' },
  { civilian: 'Leader', imposter: 'Follower' },
  { civilian: 'Hero', imposter: 'Villain' },
  { civilian: 'Guest', imposter: 'Host' },
  { civilian: 'Morning', imposter: 'Night' },
  { civilian: 'Day', imposter: 'Evening' },
  { civilian: 'Summer', imposter: 'Winter' },
  { civilian: 'Monday', imposter: 'Sunday' },
  { civilian: 'Today', imposter: 'Tomorrow' },
  { civilian: 'Past', imposter: 'Future' },
  { civilian: 'Start', imposter: 'End' },
  { civilian: 'First', imposter: 'Last' },
  { civilian: 'Early', imposter: 'Late' },
  { civilian: 'Fast', imposter: 'Slow' },
  { civilian: 'Happy', imposter: 'Angry' },
  { civilian: 'Love', imposter: 'Hate' },
  { civilian: 'Fear', imposter: 'Courage' },
  { civilian: 'Truth', imposter: 'Lie' },
  { civilian: 'Win', imposter: 'Lose' },
  { civilian: 'Give', imposter: 'Take' },
  { civilian: 'Buy', imposter: 'Sell' },
  { civilian: 'Open', imposter: 'Close' },
  { civilian: 'Push', imposter: 'Pull' },
  { civilian: 'Rise', imposter: 'Fall' },
  { civilian: 'Pen', imposter: 'Chalk' },
  { civilian: 'Pencil', imposter: 'Crayon' },
  { civilian: 'Eraser', imposter: 'Sharpener' },
  { civilian: 'Notebook', imposter: 'Diary' },
  { civilian: 'Blackboard', imposter: 'Whiteboard' },
  { civilian: 'Bag', imposter: 'Folder' },
  { civilian: 'Desk', imposter: 'Bench' },
  { civilian: 'Exam', imposter: 'Homework' },
  { civilian: 'Mark', imposter: 'Grade' },
  { civilian: 'Result', imposter: 'Report' },
  { civilian: 'Fire', imposter: 'Ice' },
  { civilian: 'Light', imposter: 'Darkness' },
  { civilian: 'Sound', imposter: 'Silence' },
  { civilian: 'Heat', imposter: 'Cold' },
  { civilian: 'Energy', imposter: 'Power' },
  { civilian: 'Speed', imposter: 'Distance' },
  { civilian: 'Force', imposter: 'Pressure' },
  { civilian: 'Gravity', imposter: 'Magnet' },
  { civilian: 'Time', imposter: 'Space' },
  { civilian: 'Life', imposter: 'Death' },
  { civilian: 'Rice', imposter: 'Quinoa' },
  { civilian: 'Wheat', imposter: 'Barley' },
  { civilian: 'Bread', imposter: 'Croissant' },
  { civilian: 'Roti', imposter: 'Paratha' },
  { civilian: 'Idli', imposter: 'Dosa' },
  { civilian: 'Upma', imposter: 'Poha' },
  { civilian: 'Pasta', imposter: 'Lasagna' },
  { civilian: 'Noodles', imposter: 'Ramen' },
  { civilian: 'Pizza', imposter: 'Calzone' },
  { civilian: 'Burger', imposter: 'Hotdog' },
  { civilian: 'Sandwich', imposter: 'Panini' },
  { civilian: 'Cake', imposter: 'Pastry' },
  { civilian: 'Ice cream', imposter: 'Sorbet' },
  { civilian: 'Chocolate', imposter: 'Fudge' },
  { civilian: 'Candy', imposter: 'Toffee' },
  { civilian: 'Biscuit', imposter: 'Cracker' },
  { civilian: 'Chips', imposter: 'Nachos' },
  { civilian: 'Popcorn', imposter: 'Cornflakes' },
  { civilian: 'Dal', imposter: 'Sambar' },
  { civilian: 'Soup', imposter: 'Stew' },
  { civilian: 'Chicken', imposter: 'Turkey' },
  { civilian: 'Fish', imposter: 'Prawn' },
  { civilian: 'Egg', imposter: 'Omelette' },
  { civilian: 'Paneer', imposter: 'Tofu' },
  { civilian: 'Butter', imposter: 'Margarine' },
  { civilian: 'Cheese', imposter: 'Mozzarella' },
  { civilian: 'Milk', imposter: 'Almond milk' },
  { civilian: 'Tea', imposter: 'Green tea' },
  { civilian: 'Coffee', imposter: 'Espresso' },
  { civilian: 'Juice', imposter: 'Smoothie' },
  { civilian: 'Soda', imposter: 'Cola' },
  { civilian: 'Beer', imposter: 'Cider' },
  { civilian: 'Wine', imposter: 'Champagne' },
  { civilian: 'Whiskey', imposter: 'Rum' },
  { civilian: 'Vodka', imposter: 'Gin' },
  { civilian: 'Sugar', imposter: 'Jaggery' },
  { civilian: 'Salt', imposter: 'Rock salt' },
  { civilian: 'Honey', imposter: 'Maple syrup' },
  { civilian: 'Jam', imposter: 'Jelly' },
  { civilian: 'Sauce', imposter: 'Ketchup' },
  { civilian: 'Pickle', imposter: 'Chutney' },
  { civilian: 'Biryani', imposter: 'Pulao' },
  { civilian: 'Fried rice', imposter: 'Schezwan rice' },
  { civilian: 'Tandoori', imposter: 'Grill' },
  { civilian: 'Curry', imposter: 'Masala' },
  { civilian: 'Samosa', imposter: 'Kachori' },
  { civilian: 'Vada', imposter: 'Pakora' },
  { civilian: 'Gulab jamun', imposter: 'Rasgulla' },
  { civilian: 'Ladoo', imposter: 'Barfi' },
  { civilian: 'Halwa', imposter: 'Kheer' },
  { civilian: 'Car', imposter: 'Limousine' },
  { civilian: 'Bike', imposter: 'Dirt bike' },
  { civilian: 'Bus', imposter: 'Shuttle' },
  { civilian: 'Train', imposter: 'Bullet train' },
  { civilian: 'Metro', imposter: 'Tram' },
  { civilian: 'Auto', imposter: 'Rickshaw' },
  { civilian: 'Taxi', imposter: 'Cab' },
  { civilian: 'Truck', imposter: 'Trailer' },
  { civilian: 'Van', imposter: 'Minivan' },
  { civilian: 'Jeep', imposter: 'SUV' },
  { civilian: 'Tractor', imposter: 'Bulldozer' },
  { civilian: 'Scooter', imposter: 'Moped' },
  { civilian: 'Bicycle', imposter: 'Tandem bike' },
  { civilian: 'Skateboard', imposter: 'Hoverboard' },
  { civilian: 'Boat', imposter: 'Ferry' },
  { civilian: 'Ship', imposter: 'Cruise' },
  { civilian: 'Submarine', imposter: 'Yacht' },
  { civilian: 'Canoe', imposter: 'Kayak' },
  { civilian: 'Airplane', imposter: 'Jet' },
  { civilian: 'Helicopter', imposter: 'Drone' },
  { civilian: 'Rocket', imposter: 'Space shuttle' },
  { civilian: 'Glider', imposter: 'Paraglider' },
  { civilian: 'Hot air balloon', imposter: 'Blimp' },
  { civilian: 'Cable car', imposter: 'Gondola' },
  { civilian: 'Elevator', imposter: 'Escalator' },
  { civilian: 'Wheelchair', imposter: 'Stroller' },
  { civilian: 'Cart', imposter: 'Trolley' },
  { civilian: 'Rickshaw', imposter: 'Cycle rickshaw' },
  { civilian: 'Ambulance', imposter: 'Fire truck' },
  { civilian: 'Police car', imposter: 'Patrol bike' },
  { civilian: 'Delivery van', imposter: 'Pickup truck' },
  { civilian: 'Tank', imposter: 'Armored vehicle' },
  { civilian: 'Fighter jet', imposter: 'Bomber' },
  { civilian: 'Spaceship', imposter: 'Satellite' },
  { civilian: 'Train engine', imposter: 'Coach' },
  { civilian: 'Platform', imposter: 'Station' },
  { civilian: 'Ticket', imposter: 'Boarding pass' },
  { civilian: 'Passport', imposter: 'Visa' },
  { civilian: 'Map', imposter: 'Compass' },
  { civilian: 'GPS', imposter: 'Radar' },
  { civilian: 'Highway', imposter: 'Expressway' },
  { civilian: 'Bridge', imposter: 'Flyover' },
  { civilian: 'Tunnel', imposter: 'Subway' },
  { civilian: 'Road', imposter: 'Street' },
  { civilian: 'Lane', imposter: 'Alley' },
  { civilian: 'Parking', imposter: 'Garage' },
  { civilian: 'Signal', imposter: 'Signboard' },
  { civilian: 'Speed breaker', imposter: 'Divider' },
  { civilian: 'Fuel', imposter: 'Diesel' },
  { civilian: 'Petrol', imposter: 'Gas' },
  { civilian: 'Chair', imposter: 'Recliner' },
  { civilian: 'Table', imposter: 'Workbench' },
  { civilian: 'Bed', imposter: 'Bunk bed' },
  { civilian: 'Sofa', imposter: 'Couch' },
  { civilian: 'Cupboard', imposter: 'Wardrobe' },
  { civilian: 'Shelf', imposter: 'Rack' },
  { civilian: 'Drawer', imposter: 'Cabinet' },
  { civilian: 'Mirror', imposter: 'Glass' },
  { civilian: 'Door', imposter: 'Gate' },
  { civilian: 'Window', imposter: 'Ventilator' },
  { civilian: 'Fan', imposter: 'Cooler' },
  { civilian: 'AC', imposter: 'HVAC' },
  { civilian: 'Heater', imposter: 'Radiator' },
  { civilian: 'Lamp', imposter: 'Lantern' },
  { civilian: 'Bulb', imposter: 'Tube light' },
  { civilian: 'Switch', imposter: 'Dimmer' },
  { civilian: 'Plug', imposter: 'Adapter' },
  { civilian: 'Wire', imposter: 'Cable' },
  { civilian: 'Battery', imposter: 'Power bank' },
  { civilian: 'Charger', imposter: 'Dock' },
  { civilian: 'Phone', imposter: 'Landline' },
  { civilian: 'Laptop', imposter: 'Chromebook' },
  { civilian: 'Tablet', imposter: 'iPad' },
  { civilian: 'TV', imposter: 'Projector' },
  { civilian: 'Remote', imposter: 'Controller' },
  { civilian: 'Mouse', imposter: 'Stylus' },
  { civilian: 'Keyboard', imposter: 'Keypad' },
  { civilian: 'Speaker', imposter: 'Soundbar' },
  { civilian: 'Headphones', imposter: 'Earbuds' },
  { civilian: 'Camera', imposter: 'DSLR' },
  { civilian: 'Bottle', imposter: 'Thermos' },
  { civilian: 'Glass', imposter: 'Tumbler' },
  { civilian: 'Plate', imposter: 'Platter' },
  { civilian: 'Bowl', imposter: 'Dish' },
  { civilian: 'Spoon', imposter: 'Ladle' },
  { civilian: 'Fork', imposter: 'Chopsticks' },
  { civilian: 'Knife', imposter: 'Cleaver' },
  { civilian: 'Pan', imposter: 'Wok' },
  { civilian: 'Pot', imposter: 'Cooker' },
  { civilian: 'Stove', imposter: 'Induction' },
  { civilian: 'Bucket', imposter: 'Tub' },
  { civilian: 'Mug', imposter: 'Cup' },
  { civilian: 'Soap', imposter: 'Shampoo' },
  { civilian: 'Towel', imposter: 'Napkin' },
  { civilian: 'Brush', imposter: 'Comb' },
  { civilian: 'Razor', imposter: 'Trimmer' },
  { civilian: 'Perfume', imposter: 'Deodorant' },
  { civilian: 'Bag', imposter: 'Suitcase' },
  { civilian: 'Wallet', imposter: 'Pouch' },
  { civilian: 'Key', imposter: 'Card' },
  { civilian: 'Cat', imposter: 'Cow' },
  { civilian: 'Dog', imposter: 'Horse' },
  { civilian: 'Lion', imposter: 'Elephant' },
  { civilian: 'Tiger', imposter: 'Monkey' },
  { civilian: 'Fish', imposter: 'Bird' },
  { civilian: 'Shark', imposter: 'Eagle' },
  { civilian: 'Snake', imposter: 'Frog' },
  { civilian: 'Lizard', imposter: 'Turtle' },
  { civilian: 'Ant', imposter: 'Butterfly' },
  { civilian: 'Bee', imposter: 'Spider' },
  { civilian: 'Apple', imposter: 'Potato' },
  { civilian: 'Banana', imposter: 'Onion' },
  { civilian: 'Mango', imposter: 'Carrot' },
  { civilian: 'Orange', imposter: 'Tomato' },
  { civilian: 'Grapes', imposter: 'Cabbage' },
  { civilian: 'Rice', imposter: 'Bread' },
  { civilian: 'Pizza', imposter: 'Biryani' },
  { civilian: 'Burger', imposter: 'Idli' },
  { civilian: 'Noodles', imposter: 'Roti' },
  { civilian: 'Cake', imposter: 'Samosa' },
  { civilian: 'Coffee', imposter: 'Lemonade' },
  { civilian: 'Tea', imposter: 'Milkshake' },
  { civilian: 'Water', imposter: 'Soda' },
  { civilian: 'Soup', imposter: 'Juice' },
  { civilian: 'Ice cream', imposter: 'Curry' },
  { civilian: 'Chocolate', imposter: 'Pickle' },
  { civilian: 'Sugar', imposter: 'Salt' },
  { civilian: 'Honey', imposter: 'Vinegar' },
  { civilian: 'Butter', imposter: 'Oil' },
  { civilian: 'Cheese', imposter: 'Dal' },
  { civilian: 'Car', imposter: 'Boat' },
  { civilian: 'Bike', imposter: 'Airplane' },
  { civilian: 'Bus', imposter: 'Ship' },
  { civilian: 'Train', imposter: 'Helicopter' },
  { civilian: 'Scooter', imposter: 'Tractor' },
  { civilian: 'Bicycle', imposter: 'Rocket' },
  { civilian: 'Auto', imposter: 'Submarine' },
  { civilian: 'Truck', imposter: 'Jet' },
  { civilian: 'Van', imposter: 'Tank' },
  { civilian: 'Metro', imposter: 'Balloon' },
  { civilian: 'Chair', imposter: 'Bed' },
  { civilian: 'Table', imposter: 'Door' },
  { civilian: 'Sofa', imposter: 'Floor' },
  { civilian: 'Cupboard', imposter: 'Mirror' },
  { civilian: 'Fan', imposter: 'Fridge' },
  { civilian: 'AC', imposter: 'Stove' },
  { civilian: 'Lamp', imposter: 'TV' },
  { civilian: 'Bed', imposter: 'Carpet' },
  { civilian: 'Pillow', imposter: 'Curtain' },
  { civilian: 'Blanket', imposter: 'Towel' },
  { civilian: 'Phone', imposter: 'Television' },
  { civilian: 'Laptop', imposter: 'Speaker' },
  { civilian: 'Tablet', imposter: 'Camera' },
  { civilian: 'Mouse', imposter: 'Remote' },
  { civilian: 'Keyboard', imposter: 'Controller' },
  { civilian: 'Charger', imposter: 'Battery' },
  { civilian: 'App', imposter: 'Game' },
  { civilian: 'Website', imposter: 'Software' },
  { civilian: 'Email', imposter: 'Call' },
  { civilian: 'Message', imposter: 'Letter' },
  { civilian: 'Doctor', imposter: 'Farmer' },
  { civilian: 'Teacher', imposter: 'Driver' },
  { civilian: 'Police', imposter: 'Chef' },
  { civilian: 'Engineer', imposter: 'Artist' },
  { civilian: 'Lawyer', imposter: 'Singer' },
  { civilian: 'Actor', imposter: 'Scientist' },
  { civilian: 'Soldier', imposter: 'Dancer' },
  { civilian: 'Pilot', imposter: 'Mechanic' },
  { civilian: 'Boss', imposter: 'Intern' },
  { civilian: 'Student', imposter: 'Principal' },
  { civilian: 'Cricket', imposter: 'Swimming' },
  { civilian: 'Football', imposter: 'Chess' },
  { civilian: 'Tennis', imposter: 'Boxing' },
  { civilian: 'Badminton', imposter: 'Running' },
  { civilian: 'Basketball', imposter: 'Yoga' },
  { civilian: 'Golf', imposter: 'Wrestling' },
  { civilian: 'Hockey', imposter: 'Gymnastics' },
  { civilian: 'Ludo', imposter: 'Marathon' },
  { civilian: 'Chess', imposter: 'Kabaddi' },
  { civilian: 'Rugby', imposter: 'Skating' },
  { civilian: 'Sun', imposter: 'Ocean' },
  { civilian: 'Moon', imposter: 'Mountain' },
  { civilian: 'Star', imposter: 'River' },
  { civilian: 'Rain', imposter: 'Fire' },
  { civilian: 'Snow', imposter: 'Desert' },
  { civilian: 'Wind', imposter: 'Earthquake' },
  { civilian: 'Sky', imposter: 'Forest' },
  { civilian: 'Cloud', imposter: 'Sand' },
  { civilian: 'Volcano', imposter: 'Iceberg' },
  { civilian: 'Lightning', imposter: 'Waterfall' },
  { civilian: 'King', imposter: 'Soldier' },
  { civilian: 'Queen', imposter: 'Servant' },
  { civilian: 'Hero', imposter: 'Villain' },
  { civilian: 'Friend', imposter: 'Stranger' },
  { civilian: 'Guest', imposter: 'Host' },
  { civilian: 'Leader', imposter: 'Follower' },
  { civilian: 'Rich', imposter: 'Poor' },
];

export const getRandomWordPair = () => {
  const randomIndex = Math.floor(Math.random() * WORD_PAIRS.length);
  return WORD_PAIRS[randomIndex];
};
